import React, { Component } from 'react';
import './workExpPage.css';
import ExpData from './../work-exp.json';
import Close from './../images/cancel.png';


interface Experience {
    Title: string;
    Description: string;
    WorkExperience: string[];
}

interface Project {
    Name: string;
    Description: string;
    WorkExperience: string[];
    Experience: Experience[];
}

class ExperienceModal extends Component<any, any>
{
    render() {

        console.log(this.props);

        return(
            <div className="ExpModalContainer mb-2" onClick={this.props.CloseModal}>
                <div className="w-100 d-inline-flex justify-content-between align-items-center mb-3">
                    <div className="ExpModalOrganizationDiv">
                        <span className="ExpModalOrganizationSpan">
                            {this.props.Organization}
                        </span>
                    </div>
                    
                    <img src={Close} className="ExpModalCloseButton" alt="Menu" onClick={this.props.CloseModal} />
                    
                </div>
                {
                    this.props.Projects.map((element : Project, indx: number) => {
                        return(
                            <div className="d-flex flex-column mt-3 p-2" key={indx}>
                                <div className="ExpModalProjects-Name text-center">
                                    <u>{element.Name}</u>
                                </div>
                                <div className="ExpModalProjects-Description mt-1">
                                    {element.Description}
                                </div>
                                <ul>
                                    {element.WorkExperience.map(
                                        (description: string, innerIndx: number) => {
                                        return(
                                        <li key={innerIndx} className="ExpModalProjects-WorkExperience">
                                            {description}
                                        </li>);
                                        }
                                    )}
                                </ul>
                                {
                                    element.Experience?.map(
                                        (exp: Experience, innerIndx: number) => {
                                            return(
                                                <div className="ExpModalProjects-Experience-Div" key={innerIndx}>
                                                    <p>
                                                        <span>{exp.Title} - {exp.Description}</span><br/>
                                                    {
                                                        exp.WorkExperience.map(
                                                            (workexp: string, expIndx) => {
                                                                return(<span key={expIndx}>{workexp}</span>);
                                                            }
                                                        )
                                                    }
                                                    </p>
                                                </div>
                                            );
                                        }
                                    )
                                }    
                            </div>
                        );
                    })
                }  
            </div>
        )
    }
}

class SummaryCard extends Component<any, any>
{
    render() {
        return(
            <div className="SummaryCardDiv d-inline-flex flex-column">
                <span className="SummaryCardDateRange p-2 d-flex align-items-center">
                    <span className="material-icons mr-3">date_range</span>{this.props.Date}
                </span>
            
                <span className="SummaryCardOrganization p-2 pt-3 d-flex align-items-center">
                    <span className="material-icons mr-3">corporate_fare</span>{this.props.Organization} 
                </span>
                <span className="SummaryCardPosition p-2 d-flex align-items-center"> 
                    <span className="material-icons mr-3">assignment_ind</span>{this.props.Position}
                </span>
                <span className="SummaryCardLocation p-2 d-flex align-items-center">
                    <span className="material-icons mr-3">location_on</span>{this.props.Location}
                </span>
                <div className="ReadMoreDiv p-2 text-center">    
                    <button onClick={this.props.LaunchModal}>
                        <span className="SummaryCardTextSpan">Read More</span>
                    </button>
                </div>
            </div>
        );
    }
}

export default class WorkExperiencePage extends Component<any, any>
{
    constructor(props: any){
        super(props);
        this.state = {
            ExpData: null,
        }
    }

    render(){

        let comp = this;

        if(this.state.ExpData !== null){
            return (
                <ExperienceModal {...this.state.ExpData} CloseModal={() => comp.setState({ExpData: null})}/>
            );
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col">
                        <h1 className="ContainerTitle text-center">MY WORK EXPERIENCE</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8 offset-md-4">
                    <ul className="WorkExpSummaryList">
                        {
                            ExpData.map(
                                (element, indx) => {
                                    return(<li className="p-1"  key={indx}><SummaryCard {...element} LaunchModal={() => comp.setState({ExpData: element})}/></li>)
                                }
                            )
                        }
                    </ul>
                    </div>
                </div>
            </div>
        );
    }
}
